//codex-- Use the page-scoped toolbar presentation.
import PageToolbar from './PageToolbar';
import React, { useEffect, useState } from "react";
import axios from "axios";
import HeadingCp from "../components/HeadingCp";
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from "react-toastify";
import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import ModalOutlookView from "../components/ModalOutlookView";
//codex-- Retain Enter search and put Clear alongside filter actions.
import { PageToolbarSearch as SearchBarCP } from './PageToolbar';

const columns = [
  { key: "id", label: "ID" },
  { key: "Subject", label: "Subject" },
  { key: "Start Date", label: "Start Date" },
  { key: "Start Time", label: "Start Time" },
  { key: "End Date", label: "End Date" },
  { key: "End Time", label: "End Time" },
  { key: "All_day_event", label: "All Day" },
  { key: "Reminder_on_off", label: "Reminder On/Off" },
  { key: "Reminder_Date", label: "Reminder Date" },
  { key: "Reminder_Time", label: "Reminder Time" },
  { key: "Meeting_Organizer", label: "Organizer" },
  { key: "Required_Attendees", label: "Required Attendees" },
  { key: "Optional_Attendees", label: "Optional Attendees" },
  { key: "Meeting_Resources", label: "Resources" },
  { key: "Billing_Information", label: "Billing Info" },
  { key: "Categories", label: "Categories" },
  { key: "Description", label: "Description" },
  { key: "Location", label: "Location" },
  { key: "Mileage", label: "Mileage" },
  { key: "Priority", label: "Priority" },
  { key: "Private", label: "Private" },
  { key: "Sensitivity", label: "Sensitivity" },
  { key: "Show_time_as", label: "Show Time As" },
];

const OutlookReportPage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [descriptionIdOpen, setDescriptionIdOpen] = useState(null);

  // (optional) basic filter state
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredLogs, setFilteredLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/outlook_crud.php`, {
        params: { getOutlookReportList: 1 },
      });
      // console.log(res.data);
      
      const data = Array.isArray(res.data[0]) ? res.data[0] : [];
      setLogs(data);
      setFilteredLogs(data);
    } catch (error) {
      toast.error("Error fetching outlook report data");
    } finally {
      setLoading(false);
    }
  };

  // Basic client-side filter (optional)
  const handleSearchChange = e => {
    const value = e.target.value;
    setSearchTerm(value);
    if (!value) {
      setFilteredLogs(logs);
    } else {
      setFilteredLogs(
        logs.filter(row =>
          columns.some(col =>
            String(row[col.key] || "")
              .toLowerCase()
              .includes(value.toLowerCase())
          )
        )
      );
    }
  };

  // to override the local filtering. Could also rely 100% on local filter if your dataset is small.
  const handleSearchClick = async () => {
    setLoading(true);
    const bodyData = {
      status: 'search_outlook',
      data: { search: searchTerm },
    };

    try {
      const response = await axios.post(`${apiUrl}/outlook_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data && Array.isArray(response.data)) {
             setLogs(response.data);
      setFilteredLogs(response.data);
        // The useEffect will run applyFilters and update filterInspection
      } else {
        setFilteredLogs([]);
        toast.error('No results found for: ' + searchTerm, { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error searching contracts', error);
      toast.error('Error searching contracts', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <HeadingCp label="Outlook Calendar Report" />

      <>{/* //codex-- Match the page toolbar reference while retaining each existing control and form owner. */}<PageToolbar title="Outlook Report  tools"><div className="flex items-center gap-4 mb-6 bg-gray-100 p-4 rounded-lg">
        {/* Search Bar */}
        <SearchBarCP search={searchTerm} handleChange={handleSearchChange} onClick={handleSearchClick} />
      </div></PageToolbar></>

      {loading ? (
        <LoadingSpinner>Loading...</LoadingSpinner>
      ) : (
        <div className="overflow-auto">
          <table className="min-w-full divide-y divide-gray-300 bg-white border rounded-lg text-xs sm:text-sm">
            <thead>
              <tr>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">ID</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Subject</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Location</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Start</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">End</th>
                {/* <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">All Day / Reminder</th> */}
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Organizer / Attendees</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Resources / Billing / Categories</th>
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Description</th>
                {/* <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Mileage</th> */}
                <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Priority</th>
                {/* <th className="py-2 px-2 text-left font-semibold text-gray-900 bg-gray-100">Show Time As</th> */}
              </tr>
            </thead>
              <tbody>
                {filteredLogs.map((log, idx) => {
                  const rowClassName = () => (idx % 2 === 0 ? "bg-white divide-x" : "bg-gray-100 divide-x");

                  return (
                    <tr key={log.id} className={rowClassName()}>
                      {/* ID and Subject */}
                      <td className="px-3 py-4 text-sm text-gray-500 font-semibold">{log.id}</td>
                      <td className="px-3 py-4 text-sm text-gray-900">{log.Subject}</td>
                      <td className="px-3 py-4 text-md text-gray-800">{log.Location}</td>

                      {/* Date/Time */}
                      <td className="px-3 py-4 text-xs text-gray-600">
                        <div>
                          <b>Start:</b> {log.Start_Date} {log.Start_Time}
                        </div>
                      </td>

                      <td className="px-3 py-4 text-xs text-gray-600">
                        <div>
                          <b>End:</b> {log.End_Date} {log.End_Time}
                        </div>
                      </td>

                      {/* All day / Reminder */}
                      {/* <td className="px-3 py-4 text-xs text-gray-700"> */}
                        {/* <div>All Day: <b>{log.All_day_event}</b></div> */}
                        {/* <div>Reminder: {log.Reminder_on_off === "On" ? "🟢" : "⚪"} {log.Reminder_Date} {log.Reminder_Time}</div> */}
                      {/* </td> */}

                      {/* Organizer & Attendees */}
                      <td className="px-3 py-4 text-xs text-gray-700">
                        <div><b>Organizer:</b> {log.Meeting_Organizer}</div>
                        {/* <div><b>Required:</b> <span className="break-all">{log.Required_Attendees}</span></div> */}
                        {/* <div><b>Optional:</b> <span className="break-all">{log.Optional_Attendees}</span></div> */}
                      </td>

                      {/* Resources, Billing, Categories */}
                      <td className="px-3 py-4 text-xs text-gray-700">
                        {/* <div><b>Resources:</b> {log.Meeting_Resources}</div> */}
                        <div className="text-blue-800">{log.Categories}</div>
                        <div><b>important:</b> {log.Priority  === "High" ? "🟢" : "⚪"}</div>
                      </td>

                      {/* Description (shortened) */}
                      <td className="px-3 py-4 text-xs text-gray-700 max-w-xs break-words">
                        <div className="truncate" title={log.Description}>
                          {/* {log.Description?.slice(0, 100) || ""}
                          {log.Description && log.Description.length > 100 ? "..." : ""} */}
                        </div>
                        {log.Description && (
                            <span
                              className="flex items-center mb-1 hover:cursor-pointer text-indigo-700"
                              onClick={() => setDescriptionIdOpen(log.id)}
                            >
                              <DocumentCheckIcon className="w-5" /> view details
                            </span>
                          )}
                          
                          {descriptionIdOpen === log.id && (
                            <ModalOutlookView
                              job={log.Description}
                              closeNotes={() => setDescriptionIdOpen(null)}
                              activeButton={true}
                            />
                          )}                        
                      </td>

                      {/* Mileage, Priority, Private, Sensitivity, Show Time As */}
                      {/* <td className="px-3 py-4 text-xs text-gray-700">{log.Mileage}</td> */}
                      <td className="px-3 py-4 text-xs text-gray-700">{log.Priority}</td>
                      {/* <td className="px-3 py-4 text-xs text-gray-700">{log.Show_time_as}</td> */}
                    </tr>
                  );
                })}
              </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OutlookReportPage;
